(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-nf-room-rules]';

  function initRoomRules(root) {
    if (!root || root.nfRoomRulesCleanup) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-nf-rr-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-nf-rr-panel]'));
    var progress = Array.prototype.slice.call(root.querySelectorAll('[data-nf-rr-progress]'));
    var tabsRail = root.querySelector('[data-nf-rr-tabs]');
    var currentNumber = root.querySelector('[data-nf-rr-current-number]');
    var currentTitle = root.querySelector('[data-nf-rr-current-title]');
    var roomVideos = {
      kitchen: root.querySelector('[data-nf-rr-kitchen-video]'),
      bath: root.querySelector('[data-nf-rr-bath-video]'),
      bed: root.querySelector('[data-nf-rr-bedroom-video]'),
      stairs: root.querySelector('[data-nf-rr-stairs-video]')
    };
    var exploreButton = root.querySelector('[data-nf-rr-explore]');
    var exploreLabel = root.querySelector('[data-nf-rr-explore-label]');
    var motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var listenerOptions = controller ? { signal: controller.signal } : false;
    var observer = null;
    var switchTimer = 0;
    var activeIndex = Math.max(0, tabs.findIndex(function (tab) {
      return tab.getAttribute('aria-selected') === 'true';
    }));

    if (!tabs.length || tabs.length !== panels.length) return;

    function isReduced() {
      return Boolean(motionQuery && motionQuery.matches);
    }

    function setMotionState() {
      root.setAttribute('data-reduced-motion', isReduced() ? 'true' : 'false');
    }

    function scrollTabIntoView(tab) {
      if (!tabsRail || !tab) return;
      var railRect = tabsRail.getBoundingClientRect();
      var tabRect = tab.getBoundingClientRect();
      if (tabRect.left >= railRect.left && tabRect.right <= railRect.right) return;
      var nextLeft = tabsRail.scrollLeft + tabRect.left - railRect.left - (railRect.width - tabRect.width) / 2;
      if (typeof tabsRail.scrollTo === 'function') {
        tabsRail.scrollTo({ left: Math.max(0, nextLeft), behavior: isReduced() ? 'auto' : 'smooth' });
      } else {
        tabsRail.scrollLeft = Math.max(0, nextLeft);
      }
    }

    function finishSwitch() {
      root.classList.remove('is-switching');
      root.setAttribute('data-state', 'ready');
      switchTimer = 0;
    }

    function setExploreState(isPlaying) {
      if (exploreLabel) exploreLabel.textContent = 'Explore';
      if (exploreButton) exploreButton.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      root.classList.remove('is-video-paused');
    }

    function resetRoomMedia() {
      root.classList.remove('is-exploring', 'is-video-paused');
      Object.keys(roomVideos).forEach(function (icon) {
        var video = roomVideos[icon];
        if (!video) return;
        video.pause();
        try {
          video.currentTime = 0;
        } catch (error) {
          // The media metadata may not have loaded yet.
        }
      });
      setExploreState(false);
    }

    function startRoomMedia() {
      var icon = root.getAttribute('data-active-icon');
      var activeVideo = roomVideos[icon];
      if (!activeVideo || root.classList.contains('is-exploring')) return;

      root.classList.add('is-exploring');
      setExploreState(true);
      if (exploreButton) exploreButton.blur();

      // Perf: the film only downloads the first time a visitor presses Explore.
      var pending = activeVideo.querySelectorAll('source[data-src]');
      if (pending.length) {
        Array.prototype.forEach.call(pending, function (source) {
          source.src = source.getAttribute('data-src');
          source.removeAttribute('data-src');
        });
        activeVideo.preload = 'auto';
        activeVideo.load();
      }
      var playPromise = activeVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          resetRoomMedia();
        });
      }
    }

    function activate(index, shouldFocus, immediate) {
      var nextIndex = (index + tabs.length) % tabs.length;
      var nextTab = tabs[nextIndex];
      var roomId = nextTab.getAttribute('data-room-id');
      var icon = nextTab.getAttribute('data-icon') || 'kitchen';
      var previousIcon = root.getAttribute('data-active-icon');

      if (!roomVideos[icon] || previousIcon !== icon || (!immediate && nextIndex === activeIndex)) {
        resetRoomMedia();
      }

      if (nextIndex !== activeIndex && !immediate && !isReduced()) {
        window.clearTimeout(switchTimer);
        root.classList.add('is-switching');
        root.setAttribute('data-state', 'switching');
        switchTimer = window.setTimeout(finishSwitch, 620);
      } else {
        finishSwitch();
      }

      tabs.forEach(function (tab, tabIndex) {
        var selected = tabIndex === nextIndex;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
      });

      panels.forEach(function (panel) {
        var selected = panel.getAttribute('data-room-id') === roomId;
        panel.hidden = !selected;
        panel.classList.toggle('is-active', selected);
      });

      progress.forEach(function (marker, markerIndex) {
        marker.classList.toggle('is-active', markerIndex <= nextIndex);
      });

      root.setAttribute('data-active-room', roomId);
      root.setAttribute('data-active-icon', icon);
      if (currentNumber) currentNumber.textContent = nextTab.getAttribute('data-number') || String(nextIndex + 1);
      if (currentTitle) currentTitle.textContent = nextTab.getAttribute('data-title') || '';
      if (exploreButton && roomVideos[icon]) {
        exploreButton.setAttribute('aria-label', 'Explore ' + (nextTab.getAttribute('data-title') || 'room') + ' film');
      }

      activeIndex = nextIndex;

      if (shouldFocus) {
        try {
          nextTab.focus({ preventScroll: true });
        } catch (error) {
          nextTab.focus();
        }
      }
      scrollTabIntoView(nextTab);
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function (event) {
        event.preventDefault();
        activate(index, false, false);
      }, listenerOptions);

      tab.addEventListener('keydown', function (event) {
        var nextIndex = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = activeIndex + 1;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = activeIndex - 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === null) return;
        event.preventDefault();
        activate(nextIndex, true, false);
      }, listenerOptions);
    });

    if (exploreButton) {
      exploreButton.addEventListener('click', function () {
        startRoomMedia();
      }, listenerOptions);
    }

    Object.keys(roomVideos).forEach(function (icon) {
      var video = roomVideos[icon];
      if (!video) return;
      video.addEventListener('ended', function () {
        resetRoomMedia();
      }, listenerOptions);
    });

    function handleBlockSelect(event) {
      var blockId = event && event.detail ? event.detail.blockId : '';
      if (!blockId) return;
      var targetIndex = tabs.findIndex(function (tab) {
        return tab.getAttribute('data-room-id') === blockId;
      });
      if (targetIndex >= 0) activate(targetIndex, false, true);
    }

    document.addEventListener('shopify:block:select', handleBlockSelect, listenerOptions);
    setMotionState();

    if (motionQuery) {
      if (typeof motionQuery.addEventListener === 'function') {
        motionQuery.addEventListener('change', setMotionState, listenerOptions);
      } else if (typeof motionQuery.addListener === 'function') {
        motionQuery.addListener(setMotionState);
      }
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          root.setAttribute('data-state', 'ready');
          observer.disconnect();
        });
      }, { threshold: 0.16 });
      observer.observe(root);
    } else {
      root.setAttribute('data-state', 'ready');
    }

    activate(activeIndex, false, true);

    root.nfRoomRulesCleanup = function () {
      window.clearTimeout(switchTimer);
      resetRoomMedia();
      if (observer) observer.disconnect();
      if (controller) controller.abort();
      if (motionQuery && typeof motionQuery.removeListener === 'function') {
        motionQuery.removeListener(setMotionState);
      }
      delete root.nfRoomRulesCleanup;
    };
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    if (context.matches && context.matches(ROOT_SELECTOR)) initRoomRules(context);
    Array.prototype.forEach.call(context.querySelectorAll(ROOT_SELECTOR), initRoomRules);
  }

  function unloadAll(scope) {
    if (!scope || !scope.querySelectorAll) return;
    if (scope.matches && scope.matches(ROOT_SELECTOR) && scope.nfRoomRulesCleanup) {
      scope.nfRoomRulesCleanup();
    }
    Array.prototype.forEach.call(scope.querySelectorAll(ROOT_SELECTOR), function (root) {
      if (root.nfRoomRulesCleanup) root.nfRoomRulesCleanup();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    unloadAll(event.target);
  });
})();